{
    "ReportIntervalLanguageFifteenMinutes": "15 minuti",
    "ReportIntervalLanguageThirtyMinutes": "30 minuti",
    "ReportIntervalLanguageOneHour": "1 ora",
    "ReportIntervalLanguageTwoHour": "2 ore",
    "ReportIntervalLanguageTypeMinute": "Verbale",
    "ReportIntervalLanguageTypeHour": "Ora",
    "ReportIntervalLanguageTypeHourPluralised": "Ore",
    "ReportIntervalLanguageInterpolated": "Totale chiamate da {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Chiamate da {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Chiamate da {}",
    "ReportIntervalTypeMinutes": "Verbale",
    "ReportIntervalTypeHours": "Ore",
    "ReportIntervalTypeDay": "Giorno",
    "ReportIntervalTypeWeek": "Settimana",
    "ReportIntervalTypeMonth": "Mese",
    "NAME": "ReportIntervalLanguage",
    "ReportIntervalEntityLanguageCallByNoValueInterpolated": "Chiamate da {} ({})",
    "ReportIntervalEntityLanguageCallByInterpolated": "Chiamate da {} {} ({})",
    "ReportIntervalTypeDayOfTheWeek": "Giorno della settimana",
    "ReportIntervalEntityTypeDevicesExtensionsAA": "Dispositivi (Estensioni\/AA)",
    "ReportIntervalEntityTypeAgents": "Agenti",
    "ReportIntervalEntityTypeGroups": "Gruppo\/Code",
    "ReportIntervalEntityTypeDNIS": "DNIS"
}